// eslint-disable-next-line import/no-cycle
import { getTemplateIframeDocument } from '@/components/template-builder/utils/helpers';
// eslint-disable-next-line import/no-cycle
import { addElementTypeByLang } from '@/composables/template-editor/TemplateEditor';

/**
 * Set segments configuration to s-segments attribute
 */
const setConditionalSegments = (selector: string, value: any): void => {
  const template = getTemplateIframeDocument();
  const element: HTMLElement | null = template?.querySelector(selector);

  if (element) {
    if (value !== null && value !== undefined && value !== '') {
      let segments;
      let rawValue = value;

      // If value is a property object with { name, setters, value }, extract the value
      if (typeof value === 'object' && value !== null && 'value' in value && 'name' in value) {
        rawValue = value.value;
      }

      // Check if rawValue is null/undefined after extraction
      if (rawValue === null || rawValue === undefined || rawValue === '') {
        element.removeAttribute('s-segments');
        addElementTypeByLang(element);
        return;
      }

      // Handle string JSON
      if (typeof rawValue === 'string') {
        try {
          segments = JSON.parse(rawValue);
        } catch (e) {
          return;
        }
      } else {
        // Handle object/array (including Vue Proxy)
        // Convert to plain object/array by JSON round-trip to remove Vue reactivity
        segments = JSON.parse(JSON.stringify(rawValue));
      }

      if (Array.isArray(segments) && segments.length > 0) {
        const jsonString = JSON.stringify(segments);
        element.setAttribute('s-segments', jsonString);
      } else {
        element.removeAttribute('s-segments');
      }
    } else {
      element.removeAttribute('s-segments');
    }

    // Update state badges
    addElementTypeByLang(element);
  }
};

export default setConditionalSegments;
